import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Header } from './models/header.interfaces';

@Component({
  selector: 'idp-header',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() content: Header = {} as Header;
  @Output() analyticsData = new EventEmitter<Event>();

  onLinkClick(event: Event): void {
    this.analyticsData.emit(event);
  }
}
